module.exports = __webpack_public_path__ + "static/img/cgal14.e7b8375.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal14.png
// module id = wLsQ
// module chunks = 1